(function () {

function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequirec490"];
var parcelRegister = parcelRequire.register;
parcelRegister("kS5XP", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", function () { return $f31d7a21d03e7a6f$export$2e2bcd8739ae039; });

var $5lsvs = parcelRequire("5lsvs");

var $dlmKU = parcelRequire("dlmKU");

var $esELE = parcelRequire("esELE");

var $dgWRh = parcelRequire("dgWRh");

var $agUaH = parcelRequire("agUaH");
function $f31d7a21d03e7a6f$var$_extends() {
    $f31d7a21d03e7a6f$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $f31d7a21d03e7a6f$var$_extends.apply(this, arguments);
}
var $f31d7a21d03e7a6f$var$Footer = function Footer(_ref) {
    var footerMenuLocationMap = _ref.footerMenuLocationMap, main = _ref.main;
    return (0, $5lsvs.h)((0, $esELE.default), $f31d7a21d03e7a6f$var$_extends({
        main: main
    }, footerMenuLocationMap));
};
var $f31d7a21d03e7a6f$var$mapStateToProps = function mapStateToProps(state) {
    return {
        footerMenuLocationMap: (0, $agUaH.footerMenuLocationListSelector)(state),
        main: (0, $dgWRh.modulesByKeySelector)(state, "main")
    };
};
var $f31d7a21d03e7a6f$export$2e2bcd8739ae039 = (0, $dlmKU.connect)($f31d7a21d03e7a6f$var$mapStateToProps)($f31d7a21d03e7a6f$var$Footer);

});
parcelRegister("esELE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a8734dc8c0c09b47$export$2e2bcd8739ae039; });

var $5lsvs = parcelRequire("5lsvs");

var $jYbVq = parcelRequire("jYbVq");

var $31oV0 = parcelRequire("31oV0");

var $bIClw = parcelRequire("bIClw");

var $bxts1 = parcelRequire("bxts1");

var $2b1Qo = parcelRequire("2b1Qo");

var $hk0DR = parcelRequire("hk0DR");

var $cF4UY = parcelRequire("cF4UY");

var $3TWOT = parcelRequire("3TWOT");
var $a8734dc8c0c09b47$var$Footer = function Footer(_ref) {
    var faqLocation = _ref.faqLocation, topLinksLocation = _ref.topLinksLocation, socialLinksLocation = _ref.socialLinksLocation, bottomLinksLocation = _ref.bottomLinksLocation, appLinksLocation = _ref.appLinksLocation, contentBlockLocation = _ref.contentBlockLocation, device = _ref.main.device;
    return (0, $5lsvs.h)((0, $jYbVq.Container), null, (0, $5lsvs.h)((0, $jYbVq.FlexContainer), null, (0, $5lsvs.h)((0, $jYbVq.LeftContainer), null, faqLocation && (0, $5lsvs.h)((0, $3TWOT.default), {
        menuLocation: faqLocation
    }), topLinksLocation && (0, $5lsvs.h)((0, $bIClw.default), {
        menuLocation: topLinksLocation
    }), socialLinksLocation && device === (0, $cF4UY.DeviceTypes).mobile && (0, $5lsvs.h)((0, $bxts1.default), {
        menuLocation: socialLinksLocation
    }), appLinksLocation && (0, $5lsvs.h)((0, $31oV0.default), {
        menuLocation: appLinksLocation
    })), (0, $5lsvs.h)((0, $jYbVq.RightContainer), null, contentBlockLocation && (0, $5lsvs.h)((0, $hk0DR.default), {
        menuLocation: contentBlockLocation
    }, socialLinksLocation && device !== (0, $cF4UY.DeviceTypes).mobile ? (0, $5lsvs.h)((0, $bxts1.default), {
        menuLocation: socialLinksLocation
    }) : undefined))), bottomLinksLocation && (0, $5lsvs.h)((0, $2b1Qo.default), {
        menuLocation: bottomLinksLocation
    }));
};
var $a8734dc8c0c09b47$export$2e2bcd8739ae039 = $a8734dc8c0c09b47$var$Footer;

});
parcelRegister("jYbVq", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $e89cdf016b573b8c$export$42a852a2b6b56249; });
$parcel$export(module.exports, "FlexContainer", function () { return $e89cdf016b573b8c$export$124d4c7bf7db9715; });
$parcel$export(module.exports, "LeftContainer", function () { return $e89cdf016b573b8c$export$77468e507dd9c979; });
$parcel$export(module.exports, "RightContainer", function () { return $e89cdf016b573b8c$export$95d89f9f2dc93b; });

var $2Iqvw = parcelRequire("2Iqvw");

var $un8VG = parcelRequire("un8VG");
var $e89cdf016b573b8c$var$_templateObject, $e89cdf016b573b8c$var$_templateObject2, $e89cdf016b573b8c$var$_templateObject3;
function $e89cdf016b573b8c$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var $e89cdf016b573b8c$var$tabletUp = (0, $un8VG.Media).tabletUp;
var $e89cdf016b573b8c$export$42a852a2b6b56249 = (0, $2Iqvw.default).div.withConfig({
    displayName: "footerStyled__Container",
    componentId: "sc-2i3zvd-0"
})([
    "&&{background-color:",
    ";padding:40px 24px;}"
], function(_ref) {
    var theme = _ref.theme;
    return theme.pearlGray;
});
var $e89cdf016b573b8c$export$124d4c7bf7db9715 = (0, $2Iqvw.default).div.withConfig({
    displayName: "footerStyled__FlexContainer",
    componentId: "sc-2i3zvd-1"
})([
    "&&{",
    ";}"
], $e89cdf016b573b8c$var$tabletUp($e89cdf016b573b8c$var$_templateObject || ($e89cdf016b573b8c$var$_templateObject = $e89cdf016b573b8c$var$_taggedTemplateLiteral([
    "\n    display: flex;\n    justify-content: center;\n  "
]))));
var $e89cdf016b573b8c$export$77468e507dd9c979 = (0, $2Iqvw.default).div.withConfig({
    displayName: "footerStyled__LeftContainer",
    componentId: "sc-2i3zvd-2"
})([
    "&&{width:100%;max-width:380px;",
    ";}"
], $e89cdf016b573b8c$var$tabletUp($e89cdf016b573b8c$var$_templateObject2 || ($e89cdf016b573b8c$var$_templateObject2 = $e89cdf016b573b8c$var$_taggedTemplateLiteral([
    "\n    margin-right: 100px;\n  "
]))));
var $e89cdf016b573b8c$export$dd5ccedcb65222b0 = (0, $2Iqvw.default).div.withConfig({
    displayName: "footerStyled__SocialPadding",
    componentId: "sc-2i3zvd-3"
})([
    "&&{padding:40px 0;}"
]);
var $e89cdf016b573b8c$export$95d89f9f2dc93b = (0, $2Iqvw.default).div.withConfig({
    displayName: "footerStyled__RightContainer",
    componentId: "sc-2i3zvd-4"
})([
    "&&{margin-top:40px;",
    ";}"
], $e89cdf016b573b8c$var$tabletUp($e89cdf016b573b8c$var$_templateObject3 || ($e89cdf016b573b8c$var$_templateObject3 = $e89cdf016b573b8c$var$_taggedTemplateLiteral([
    "\n    margin-top: 0;\n  "
]))));

});

parcelRegister("31oV0", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2334cb62f8ca7218$export$2e2bcd8739ae039; });

var $5lsvs = parcelRequire("5lsvs");

var $lfbtx = parcelRequire("lfbtx");

var $dBtTp = parcelRequire("dBtTp");

var $iUbYG = parcelRequire("iUbYG");
var $2334cb62f8ca7218$var$FooterAppLinks = function FooterAppLinks(_ref) {
    var _ref$menuLocation = _ref.menuLocation, _ref$menuLocation$par = _ref$menuLocation.parentItem, _ref$menuLocation$par2 = _ref$menuLocation$par === void 0 ? {} : _ref$menuLocation$par, anchorText = _ref$menuLocation$par2.anchorText, menuItemList = _ref$menuLocation.menuItemList;
    var testIdPrefix = (0, $iUbYG.getTestID)((0, $iUbYG.E2E).project.suffix, (0, $iUbYG.E2E).section.footer, (0, $iUbYG.E2E).subsection.footer.app);
    return (0, $5lsvs.h)((0, $dBtTp.Container), null, (0, $5lsvs.h)((0, $dBtTp.GetApp), null, anchorText), (0, $5lsvs.h)((0, $iUbYG.E2ETestingProvider), {
        testIdPrefix: testIdPrefix
    }, (0, $5lsvs.h)((0, $dBtTp.BadgeContainer), {
        "data-testid": (0, $iUbYG.getTestID)(testIdPrefix, (0, $iUbYG.E2E).component.container)
    }, menuItemList.map(function(item) {
        return (0, $5lsvs.h)((0, $lfbtx.default), {
            item: item,
            key: item.id
        });
    }))));
};
var $2334cb62f8ca7218$export$2e2bcd8739ae039 = $2334cb62f8ca7218$var$FooterAppLinks;

});
parcelRegister("lfbtx", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f773e67777a91fd6$export$2e2bcd8739ae039; });

var $5lsvs = parcelRequire("5lsvs");

var $EGFUz = parcelRequire("EGFUz");

var $iKOCB = parcelRequire("iKOCB");
var $f773e67777a91fd6$var$footerDesktopFactory = (0, $iKOCB.default)();
var $f773e67777a91fd6$var$FooterItem = function FooterItem(_ref) {
    var item = _ref.item, isBottomItem = _ref.isBottomItem, isBold = _ref.isBold;
    var Component = (0, $EGFUz.useMemo)(function() {
        return $f773e67777a91fd6$var$footerDesktopFactory.mapNavItem(item);
    }, [
        item
    ]);
    return Component ? (0, $5lsvs.h)(Component, {
        isBottomItem: isBottomItem,
        item: item,
        isBold: isBold
    }) : null;
};
var $f773e67777a91fd6$export$2e2bcd8739ae039 = $f773e67777a91fd6$var$FooterItem;

});
parcelRegister("iKOCB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $da73ca49553162a3$export$2e2bcd8739ae039; });

var $i4N9t = parcelRequire("i4N9t");

var $fm9nK = parcelRequire("fm9nK");

var $j8GRE = parcelRequire("j8GRE");

var $2PuIS = parcelRequire("2PuIS");

var $hYMj9 = parcelRequire("hYMj9");

var $5jkFC = parcelRequire("5jkFC");

var $7xMpn = parcelRequire("7xMpn");
function $da73ca49553162a3$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $da73ca49553162a3$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $da73ca49553162a3$var$_typeof(o);
}
function $da73ca49553162a3$var$_defineProperty(obj, key, value) {
    key = $da73ca49553162a3$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $da73ca49553162a3$var$_toPropertyKey(t) {
    var i = $da73ca49553162a3$var$_toPrimitive(t, "string");
    return "symbol" == $da73ca49553162a3$var$_typeof(i) ? i : i + "";
}
function $da73ca49553162a3$var$_toPrimitive(t, r) {
    if ("object" != $da73ca49553162a3$var$_typeof(t) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != $da73ca49553162a3$var$_typeof(i)) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
var $da73ca49553162a3$var$FooterFactory = function FooterFactory() {
    var footerItemMapper = $da73ca49553162a3$var$_defineProperty($da73ca49553162a3$var$_defineProperty($da73ca49553162a3$var$_defineProperty($da73ca49553162a3$var$_defineProperty($da73ca49553162a3$var$_defineProperty({}, (0, $2PuIS.MenuItemTypes).menu, (0, $fm9nK.default)), (0, $2PuIS.MenuItemTypes).item, (0, $i4N9t.default)), (0, $2PuIS.MenuItemTypes).contentBlock, (0, $j8GRE.default)), (0, $hYMj9.PlaceholderEnum).DoNotSellMyInfo, (0, $5jkFC.default)), (0, $hYMj9.PlaceholderEnum).ManageCookies, (0, $7xMpn.default));
    return {
        mapNavItem: function mapNavItem(item) {
            var _a;
            var itemAsItemModel = item;
            var itemType = itemAsItemModel.placeholder && ((_a = itemAsItemModel.placeholder) === null || _a === void 0 ? void 0 : _a.type) || "";
            return footerItemMapper[itemType] || footerItemMapper[item.__typename];
        }
    };
};
var $da73ca49553162a3$export$2e2bcd8739ae039 = $da73ca49553162a3$var$FooterFactory;

});
parcelRegister("i4N9t", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $d28eba43a7b2330d$export$2e2bcd8739ae039; });

var $5lsvs = parcelRequire("5lsvs");

var $jERmq = parcelRequire("jERmq");

var $iUbYG = parcelRequire("iUbYG");

var $gRMDW = parcelRequire("gRMDW");

var $2rx72 = parcelRequire("2rx72");

var $8hfgu = parcelRequire("8hfgu");
var $d28eba43a7b2330d$var$FooterLink = function FooterLink(_ref) {
    var item = _ref.item, onClick = _ref.onClick, isBottomItem = _ref.isBottomItem, isBold = _ref.isBold;
    var _useE2ETesting = (0, $iUbYG.useE2ETesting)(), testIdPrefix = _useE2ETesting.testIdPrefix;
    var itemModel = item;
    var anchorText = itemModel.anchorText, itemName = itemModel.itemName, menuImageUrl = itemModel.menuImageUrl, itemType = itemModel.itemType;
    var isFeaturedLink = itemType === (0, $jERmq.ItemTypes).featuredLink;
    var elementTypeID = !!menuImageUrl ? (0, $iUbYG.E2E).component.icon : (0, $iUbYG.E2E).component.link;
    var testIdValue = (0, $iUbYG.getTestID)(testIdPrefix, elementTypeID, (0, $iUbYG.getDataTestIdSuffix)(itemName));
    return (0, $5lsvs.h)((0, $2rx72.FooterItem), {
        isBottomItem: isBottomItem,
        isBold: isBold,
        isFeaturedLink: isFeaturedLink
    }, (0, $5lsvs.h)((0, $8hfgu.default), {
        item: itemModel,
        onClick: onClick,
        "data-testid": testIdValue
    }, menuImageUrl && (0, $5lsvs.h)((0, $gRMDW.ItemIcon), {
        alt: itemName || anchorText,
        src: menuImageUrl,
        hasContent: !!anchorText
    }), anchorText));
};
var $d28eba43a7b2330d$export$2e2bcd8739ae039 = $d28eba43a7b2330d$var$FooterLink;

});
parcelRegister("2rx72", function(module, exports) {

$parcel$export(module.exports, "FooterItem", function () { return $1c77c9d582983a07$export$cbef165a0b571911; });

var $2Iqvw = parcelRequire("2Iqvw");

var $7VlUj = parcelRequire("7VlUj");

var $dK4Ik = parcelRequire("dK4Ik");

var $9twIs = parcelRequire("9twIs");
var $1c77c9d582983a07$export$cbef165a0b571911 = (0, $2Iqvw.default).li.withConfig({
    displayName: "footerLinkStyled__FooterItem",
    componentId: "sc-1wir6v1-0"
})([
    "&&{",
    ";align-items:center;color:",
    ";display:flex;justify-content:space-between;}&&:hover{color:",
    ";}"
], function(_ref) {
    var isBold = _ref.isBold, isFeaturedLink = _ref.isFeaturedLink;
    return isFeaturedLink && (0, $9twIs.Headline4dmTemplate) || isBold && (0, $7VlUj.Body3Template) || (0, $dK4Ik.Body4Template);
}, function(_ref2) {
    var theme = _ref2.theme, isBottomItem = _ref2.isBottomItem;
    return isBottomItem ? theme.medGray : theme.darkGray;
}, function(_ref3) {
    var theme = _ref3.theme;
    return theme.oneAppBlue;
});

});


parcelRegister("fm9nK", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b2e0302631311a00$export$2e2bcd8739ae039; });

var $5lsvs = parcelRequire("5lsvs");

var $i4N9t = parcelRequire("i4N9t");

var $1rrYY = parcelRequire("1rrYY");
var $b2e0302631311a00$var$FooterMenu = function FooterMenu(_ref) {
    var item = _ref.item, isBottomItem = _ref.isBottomItem;
    var menuItemList = item.menuItemList;
    return (0, $5lsvs.h)((0, $1rrYY.Container), null, (0, $5lsvs.h)((0, $1rrYY.FooterMenuContainer), null, menuItemList.map(function(footerItem) {
        return (0, $5lsvs.h)((0, $i4N9t.default), {
            key: footerItem.id,
            isBottomItem: isBottomItem,
            item: footerItem
        });
    })));
};
var $b2e0302631311a00$export$2e2bcd8739ae039 = $b2e0302631311a00$var$FooterMenu;

});
parcelRegister("1rrYY", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $10ce04c7b094b888$export$42a852a2b6b56249; });
$parcel$export(module.exports, "FooterMenuContainer", function () { return $10ce04c7b094b888$export$bf6efbe6614cd61; });

var $2Iqvw = parcelRequire("2Iqvw");

var $un8VG = parcelRequire("un8VG");
var $10ce04c7b094b888$var$_templateObject;
function $10ce04c7b094b888$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var $10ce04c7b094b888$var$tabletUp = (0, $un8VG.Media).tabletUp;
var $10ce04c7b094b888$export$42a852a2b6b56249 = (0, $2Iqvw.default).div.withConfig({
    displayName: "footerMenuStyled__Container",
    componentId: "sc-1lt104o-0"
})([
    "&&{}"
]);
var $10ce04c7b094b888$export$bf6efbe6614cd61 = (0, $2Iqvw.default).ul.withConfig({
    displayName: "footerMenuStyled__FooterMenuContainer",
    componentId: "sc-1lt104o-1"
})([
    "&&{list-style:none;padding:0;margin:0;display:grid;grid-gap:16px;",
    ";}&& li{margin:0;}&& li span{color:",
    ";font-size:14px;font-weight:700;margin:0;}"
], $10ce04c7b094b888$var$tabletUp($10ce04c7b094b888$var$_templateObject || ($10ce04c7b094b888$var$_templateObject = $10ce04c7b094b888$var$_taggedTemplateLiteral([
    "\n    grid-template-rows: repeat(6, 1fr);\n    grid-auto-flow: column;\n  "
]))), function(_ref) {
    var theme = _ref.theme;
    return theme.medGray;
});

});


parcelRegister("j8GRE", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $def003a9e341b872$export$2e2bcd8739ae039; });

var $5lsvs = parcelRequire("5lsvs");

var $21f4Q = parcelRequire("21f4Q");
var $def003a9e341b872$var$FooterContentBlock = function FooterContentBlock(_ref) {
    var item = _ref.item;
    var text = item.text;
    return (0, $5lsvs.h)((0, $21f4Q.Container), null, text.getContentValue());
};
var $def003a9e341b872$export$2e2bcd8739ae039 = $def003a9e341b872$var$FooterContentBlock;

});
parcelRegister("21f4Q", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $17875ecc4a398c0f$export$42a852a2b6b56249; });

var $2Iqvw = parcelRequire("2Iqvw");

var $kUpQC = parcelRequire("kUpQC");
var $17875ecc4a398c0f$export$42a852a2b6b56249 = (0, $2Iqvw.default)((0, $kUpQC.Body6)).attrs({
    as: "div"
}).withConfig({
    displayName: "footerContentBlockStyled__Container",
    componentId: "sc-1e6l87e-0"
})([
    "&&{color:",
    ";margin-bottom:40px;}&& p{color:",
    ";margin:0 0 10px;font-size:",
    ";font-weight:",
    ";font-style:normal;line-height:",
    ";letter-spacing:",
    ";}&& p:first-child{margin-top:0;}&& a{text-decoration:none;color:",
    ";}"
], function(_ref) {
    var theme = _ref.theme;
    return theme.medGray;
}, function(_ref2) {
    var theme = _ref2.theme;
    return theme.medGray;
}, (0, $kUpQC.Body6Template).fontSize, (0, $kUpQC.Body6Template).fontWeight, (0, $kUpQC.Body6Template).lineHeight, (0, $kUpQC.Body6Template).letterSpacing, function(_ref3) {
    var theme = _ref3.theme;
    return theme.oneAppBlue;
});

});


parcelRegister("5jkFC", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3ddec2c7a6d5ce1e$export$2e2bcd8739ae039; });

var $5lsvs = parcelRequire("5lsvs");

var $EGFUz = parcelRequire("EGFUz");

var $82JPL = parcelRequire("82JPL");

var $c7AxI = parcelRequire("c7AxI");

var $3vULv = parcelRequire("3vULv");

var $8hfgu = parcelRequire("8hfgu");

var $2rx72 = parcelRequire("2rx72");
var $3ddec2c7a6d5ce1e$var$DoNotSellMyInfoLink = function DoNotSellMyInfoLink(_ref) {
    var item = _ref.item;
    var itemModel = item;
    var anchorText = itemModel.anchorText;
    var _useEventHandler = (0, $c7AxI.useEventHandler)(), dispatchEvent = _useEventHandler.dispatchEvent;
    var handleLinkClick = (0, $EGFUz.useCallback)(function(event) {
        event.preventDefault();
        dispatchEvent((0, $82JPL.SupportedEvents).onDnsClick);
    }, [
        dispatchEvent
    ]);
    return (0, $5lsvs.h)((0, $2rx72.FooterItem), null, (0, $5lsvs.h)((0, $8hfgu.default), {
        item: itemModel,
        onClick: handleLinkClick,
        id: (0, $3vULv.FOOTER_ID_DNS)
    }, anchorText));
};
var $3ddec2c7a6d5ce1e$export$2e2bcd8739ae039 = $3ddec2c7a6d5ce1e$var$DoNotSellMyInfoLink;

});

parcelRegister("7xMpn", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $57e12a5c437cf6e1$export$2e2bcd8739ae039; });

var $5lsvs = parcelRequire("5lsvs");

var $EGFUz = parcelRequire("EGFUz");

var $82JPL = parcelRequire("82JPL");

var $c7AxI = parcelRequire("c7AxI");

var $3vULv = parcelRequire("3vULv");

var $2rx72 = parcelRequire("2rx72");

var $8hfgu = parcelRequire("8hfgu");
var $57e12a5c437cf6e1$var$ManageCookiesLink = function ManageCookiesLink(_ref) {
    var item = _ref.item;
    var itemModel = item;
    var anchorText = itemModel.anchorText;
    var _useEventHandler = (0, $c7AxI.useEventHandler)(), dispatchEvent = _useEventHandler.dispatchEvent;
    var handleLinkClick = (0, $EGFUz.useCallback)(function(event) {
        event.preventDefault();
        dispatchEvent((0, $82JPL.SupportedEvents).onManageCookiesClick);
    }, [
        dispatchEvent
    ]);
    return (0, $5lsvs.h)((0, $2rx72.FooterItem), null, (0, $5lsvs.h)((0, $8hfgu.default), {
        item: itemModel,
        onClick: handleLinkClick,
        id: (0, $3vULv.FOOTER_ID_MANAGE_COOKIES)
    }, anchorText));
};
var $57e12a5c437cf6e1$export$2e2bcd8739ae039 = $57e12a5c437cf6e1$var$ManageCookiesLink;

});



parcelRegister("dBtTp", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $9e75eb26e17fe4e3$export$42a852a2b6b56249; });
$parcel$export(module.exports, "GetApp", function () { return $9e75eb26e17fe4e3$export$56752c5ff04def75; });
$parcel$export(module.exports, "BadgeContainer", function () { return $9e75eb26e17fe4e3$export$f710265eb5a003da; });

var $2Iqvw = parcelRequire("2Iqvw");

var $kUpQC = parcelRequire("kUpQC");

var $un8VG = parcelRequire("un8VG");
var $9e75eb26e17fe4e3$var$_templateObject;
function $9e75eb26e17fe4e3$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var $9e75eb26e17fe4e3$var$tabletUp = (0, $un8VG.Media).tabletUp;
var $9e75eb26e17fe4e3$export$42a852a2b6b56249 = (0, $2Iqvw.default).div.withConfig({
    displayName: "footerAppLinksStyled__Container",
    componentId: "sc-bdyfl4-0"
})([
    "&&{",
    ";}"
], $9e75eb26e17fe4e3$var$tabletUp($9e75eb26e17fe4e3$var$_templateObject || ($9e75eb26e17fe4e3$var$_templateObject = $9e75eb26e17fe4e3$var$_taggedTemplateLiteral([
    "\n    margin-top: 30px;\n  "
]))));
var $9e75eb26e17fe4e3$export$56752c5ff04def75 = (0, $2Iqvw.default)((0, $kUpQC.Body1)).withConfig({
    displayName: "footerAppLinksStyled__GetApp",
    componentId: "sc-bdyfl4-1"
})([
    "&&{margin:0 0 16px 0;}"
]);
var $9e75eb26e17fe4e3$export$f710265eb5a003da = (0, $2Iqvw.default).div.withConfig({
    displayName: "footerAppLinksStyled__BadgeContainer",
    componentId: "sc-bdyfl4-2"
})([
    "&&{display:grid;grid-gap:8px;grid-auto-flow:column;width:fit-content;}"
]);

});


parcelRegister("bIClw", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $88818c7d460ceecd$export$2e2bcd8739ae039; });

var $5lsvs = parcelRequire("5lsvs");

var $lfbtx = parcelRequire("lfbtx");

var $aaEyH = parcelRequire("aaEyH");

var $iUbYG = parcelRequire("iUbYG");
var $88818c7d460ceecd$var$FooterTopLinks = function FooterTopLinks(_ref) {
    var menuItemList = _ref.menuLocation.menuItemList;
    var testIdPrefix = (0, $iUbYG.getTestID)((0, $iUbYG.E2E).project.suffix, (0, $iUbYG.E2E).section.footer, (0, $iUbYG.E2E).subsection.footer.top);
    return (0, $5lsvs.h)((0, $iUbYG.E2ETestingProvider), {
        testIdPrefix: testIdPrefix
    }, (0, $5lsvs.h)((0, $aaEyH.Container), {
        "data-testid": (0, $iUbYG.getTestID)(testIdPrefix, (0, $iUbYG.E2E).component.container)
    }, menuItemList.map(function(menu) {
        return (0, $5lsvs.h)((0, $lfbtx.default), {
            key: menu.id,
            item: menu,
            isBold: true
        });
    })));
};
var $88818c7d460ceecd$export$2e2bcd8739ae039 = $88818c7d460ceecd$var$FooterTopLinks;

});
parcelRegister("aaEyH", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $767a4ca652e0b9a6$export$42a852a2b6b56249; });

var $2Iqvw = parcelRequire("2Iqvw");

var $un8VG = parcelRequire("un8VG");
var $767a4ca652e0b9a6$var$_templateObject;
function $767a4ca652e0b9a6$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var $767a4ca652e0b9a6$var$tabletUp = (0, $un8VG.Media).tabletUp;
var $767a4ca652e0b9a6$export$42a852a2b6b56249 = (0, $2Iqvw.default).ul.withConfig({
    displayName: "footerTopLinksStyled__Container",
    componentId: "sc-gbbrr2-0"
})([
    "&&{list-style:none;padding:0;margin:0;display:grid;grid-gap:16px;",
    ";}"
], $767a4ca652e0b9a6$var$tabletUp($767a4ca652e0b9a6$var$_templateObject || ($767a4ca652e0b9a6$var$_templateObject = $767a4ca652e0b9a6$var$_taggedTemplateLiteral([
    "\n    grid-template-rows: repeat(5, 1fr);\n    grid-auto-flow: column;\n  "
]))));

});


parcelRegister("bxts1", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $86699f207786b3d3$export$2e2bcd8739ae039; });

var $5lsvs = parcelRequire("5lsvs");

var $lfbtx = parcelRequire("lfbtx");

var $dzH9l = parcelRequire("dzH9l");

var $iUbYG = parcelRequire("iUbYG");
var $86699f207786b3d3$var$FooterSocialLinks = function FooterSocialLinks(_ref) {
    var menuItemList = _ref.menuLocation.menuItemList;
    var testIdPrefix = (0, $iUbYG.getTestID)((0, $iUbYG.E2E).project.suffix, (0, $iUbYG.E2E).section.footer, (0, $iUbYG.E2E).subsection.footer.social);
    return (0, $5lsvs.h)((0, $iUbYG.E2ETestingProvider), {
        testIdPrefix: testIdPrefix
    }, (0, $5lsvs.h)((0, $dzH9l.SocialPadding), null, (0, $5lsvs.h)((0, $dzH9l.Container), {
        "data-testid": (0, $iUbYG.getTestID)(testIdPrefix, (0, $iUbYG.E2E).component.container)
    }, menuItemList.map(function(menu) {
        return (0, $5lsvs.h)((0, $lfbtx.default), {
            key: menu.id,
            item: menu
        });
    }))));
};
var $86699f207786b3d3$export$2e2bcd8739ae039 = $86699f207786b3d3$var$FooterSocialLinks;

});
parcelRegister("dzH9l", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $9e2003e62692cd64$export$42a852a2b6b56249; });
$parcel$export(module.exports, "SocialPadding", function () { return $9e2003e62692cd64$export$dd5ccedcb65222b0; });

var $2Iqvw = parcelRequire("2Iqvw");

var $un8VG = parcelRequire("un8VG");
var $9e2003e62692cd64$var$_templateObject;
function $9e2003e62692cd64$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var $9e2003e62692cd64$var$tabletUp = (0, $un8VG.Media).tabletUp;
var $9e2003e62692cd64$export$42a852a2b6b56249 = (0, $2Iqvw.default).ul.withConfig({
    displayName: "footerSocialLinksStyled__Container",
    componentId: "sc-1elhyyi-0"
})([
    "&&{display:grid;grid-gap:16px;grid-auto-flow:column;width:fit-content;margin:0;padding:0;}&& li{margin-right:0;}"
]);
var $9e2003e62692cd64$export$dd5ccedcb65222b0 = (0, $2Iqvw.default).div.withConfig({
    displayName: "footerSocialLinksStyled__SocialPadding",
    componentId: "sc-1elhyyi-1"
})([
    "&&{padding:40px 0;",
    ";}"
], $9e2003e62692cd64$var$tabletUp($9e2003e62692cd64$var$_templateObject || ($9e2003e62692cd64$var$_templateObject = $9e2003e62692cd64$var$_taggedTemplateLiteral([
    "\n    padding: 0;\n    margin-left: auto;\n  "
]))));

});


parcelRegister("2b1Qo", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $195e0a08fdf46c6b$export$2e2bcd8739ae039; });

var $5lsvs = parcelRequire("5lsvs");

var $lfbtx = parcelRequire("lfbtx");

var $iDgaZ = parcelRequire("iDgaZ");

var $iUbYG = parcelRequire("iUbYG");
var $195e0a08fdf46c6b$var$FooterBottomLinks = function FooterBottomLinks(_ref) {
    var menuItemList = _ref.menuLocation.menuItemList;
    var testIdPrefix = (0, $iUbYG.getTestID)((0, $iUbYG.E2E).project.suffix, (0, $iUbYG.E2E).section.footer, (0, $iUbYG.E2E).subsection.footer.bottom);
    return (0, $5lsvs.h)((0, $iUbYG.E2ETestingProvider), {
        testIdPrefix: testIdPrefix
    }, (0, $5lsvs.h)((0, $iDgaZ.Container), {
        "data-testid": (0, $iUbYG.getTestID)(testIdPrefix, (0, $iUbYG.E2E).component.container)
    }, (0, $5lsvs.h)((0, $iDgaZ.FooterMenuContainer), null, menuItemList.map(function(item) {
        return (0, $5lsvs.h)((0, $lfbtx.default), {
            key: item.id,
            item: item,
            isBottomItem: true
        });
    }))));
};
var $195e0a08fdf46c6b$export$2e2bcd8739ae039 = $195e0a08fdf46c6b$var$FooterBottomLinks;

});
parcelRegister("iDgaZ", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $d9086acb9ac09e63$export$42a852a2b6b56249; });
$parcel$export(module.exports, "FooterMenuContainer", function () { return $d9086acb9ac09e63$export$bf6efbe6614cd61; });

var $2Iqvw = parcelRequire("2Iqvw");

var $un8VG = parcelRequire("un8VG");
var $d9086acb9ac09e63$var$_templateObject, $d9086acb9ac09e63$var$_templateObject2;
function $d9086acb9ac09e63$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var $d9086acb9ac09e63$var$tabletUp = (0, $un8VG.Media).tabletUp;
var $d9086acb9ac09e63$export$42a852a2b6b56249 = (0, $2Iqvw.default).div.withConfig({
    displayName: "footerLinksMenuStyled__Container",
    componentId: "sc-13obt40-0"
})([
    "&&{width:100%;max-width:630px;margin:0 auto;margin-top:40px;",
    ";}"
], $d9086acb9ac09e63$var$tabletUp($d9086acb9ac09e63$var$_templateObject || ($d9086acb9ac09e63$var$_templateObject = $d9086acb9ac09e63$var$_taggedTemplateLiteral([
    "\n    margin-top: 48px;\n  "
]))));
var $d9086acb9ac09e63$export$bf6efbe6614cd61 = (0, $2Iqvw.default).ul.withConfig({
    displayName: "footerLinksMenuStyled__FooterMenuContainer",
    componentId: "sc-13obt40-1"
})([
    "&&{list-style:none;padding:0;margin:0;display:flex;flex-wrap:wrap;",
    ";}&& > li{padding-right:10px;margin-bottom:8px;margin-right:10px;border-right:1px solid ",
    ";}&& > li a{font-weight:400;}&& > li:last-of-type{border:none;}"
], $d9086acb9ac09e63$var$tabletUp($d9086acb9ac09e63$var$_templateObject2 || ($d9086acb9ac09e63$var$_templateObject2 = $d9086acb9ac09e63$var$_taggedTemplateLiteral([
    "\n    justify-content: center;\n  "
]))), function(_ref) {
    var theme = _ref.theme;
    return theme.lighterGray;
});

});


parcelRegister("hk0DR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9c4cd6af33c2691$export$2e2bcd8739ae039; });

var $5lsvs = parcelRequire("5lsvs");

var $lfbtx = parcelRequire("lfbtx");

var $6IqIR = parcelRequire("6IqIR");

var $iUbYG = parcelRequire("iUbYG");
var $c9c4cd6af33c2691$var$FooterContentBlock = function FooterContentBlock(_ref) {
    var menuItemList = _ref.menuLocation.menuItemList, children = _ref.children;
    var testIdPrefix = (0, $iUbYG.getTestID)((0, $iUbYG.E2E).project.suffix, (0, $iUbYG.E2E).section.footer, (0, $iUbYG.E2E).subsection.footer.content);
    return (0, $5lsvs.h)((0, $iUbYG.E2ETestingProvider), {
        testIdPrefix: testIdPrefix
    }, (0, $5lsvs.h)((0, $6IqIR.Container), {
        "data-testid": (0, $iUbYG.getTestID)(testIdPrefix, (0, $iUbYG.E2E).component.container)
    }, (0, $5lsvs.h)((0, $6IqIR.FooterMenuContainer), null, menuItemList.map(function(item) {
        return (0, $5lsvs.h)((0, $lfbtx.default), {
            key: item.id,
            item: item
        });
    }), children)));
};
var $c9c4cd6af33c2691$export$2e2bcd8739ae039 = $c9c4cd6af33c2691$var$FooterContentBlock;

});
parcelRegister("6IqIR", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $4e3b94ad294c111a$export$42a852a2b6b56249; });
$parcel$export(module.exports, "FooterMenuContainer", function () { return $4e3b94ad294c111a$export$bf6efbe6614cd61; });

var $2Iqvw = parcelRequire("2Iqvw");

var $un8VG = parcelRequire("un8VG");
var $4e3b94ad294c111a$var$_templateObject;
function $4e3b94ad294c111a$var$_taggedTemplateLiteral(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
var $4e3b94ad294c111a$var$tabletUp = (0, $un8VG.Media).tabletUp;
var $4e3b94ad294c111a$export$42a852a2b6b56249 = (0, $2Iqvw.default).div.withConfig({
    displayName: "footerContentBlockStyled__Container",
    componentId: "sc-lglh0g-0"
})([
    "&&{max-width:620px;display:flex;flex-wrap:wrap;}&& > a{margin-right:30px;}"
]);
var $4e3b94ad294c111a$export$bf6efbe6614cd61 = (0, $2Iqvw.default).div.withConfig({
    displayName: "footerContentBlockStyled__FooterMenuContainer",
    componentId: "sc-lglh0g-1"
})([
    "&&{list-style:none;padding:0;margin:0;display:flex;flex-wrap:wrap;",
    ";}&& > li{padding-right:20px;margin-right:20px;}&& > li a{font-weight:400;}&& > li:last-of-type{border:none;}"
], $4e3b94ad294c111a$var$tabletUp($4e3b94ad294c111a$var$_templateObject || ($4e3b94ad294c111a$var$_templateObject = $4e3b94ad294c111a$var$_taggedTemplateLiteral([
    "\n    justify-content: center;\n  "
]))));

});


parcelRegister("3TWOT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2d742292b55661af$export$2e2bcd8739ae039; });

var $5lsvs = parcelRequire("5lsvs");

var $lfbtx = parcelRequire("lfbtx");

var $bvy2E = parcelRequire("bvy2E");

var $iUbYG = parcelRequire("iUbYG");
var $2d742292b55661af$var$FooterFaq = function FooterFaq(_ref) {
    var menuItemList = _ref.menuLocation.menuItemList;
    var testIdPrefix = (0, $iUbYG.getTestID)((0, $iUbYG.E2E).project.suffix, (0, $iUbYG.E2E).section.footer, (0, $iUbYG.E2E).subsection.footer.faq);
    return (0, $5lsvs.h)((0, $iUbYG.E2ETestingProvider), {
        testIdPrefix: testIdPrefix
    }, (0, $5lsvs.h)((0, $bvy2E.Container), {
        "data-testid": (0, $iUbYG.getTestID)(testIdPrefix, (0, $iUbYG.E2E).component.container)
    }, menuItemList.map(function(menu) {
        return (0, $5lsvs.h)((0, $lfbtx.default), {
            key: menu.id,
            item: menu,
            isBold: true
        });
    })));
};
var $2d742292b55661af$export$2e2bcd8739ae039 = $2d742292b55661af$var$FooterFaq;

});
parcelRegister("bvy2E", function(module, exports) {

$parcel$export(module.exports, "Container", function () { return $860cfef7ecded7fd$export$42a852a2b6b56249; });

var $2Iqvw = parcelRequire("2Iqvw");
var $860cfef7ecded7fd$export$42a852a2b6b56249 = (0, $2Iqvw.default).ul.withConfig({
    displayName: "footerFaqStyled__Container",
    componentId: "sc-fh9m5x-0"
})([
    "&&{border-bottom:1px solid ",
    ";margin:0;padding:0;margin-bottom:15px;padding-bottom:7px;}&& li{margin-bottom:8px;}"
], function(_ref) {
    var theme = _ref.theme;
    return theme.lighterGray;
});

});




})();
//# sourceMappingURL=footer.aeddc1ed.js.map
